import React from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  Row,
  Col,
  Form,
  Button,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { TbEdit } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
const UserInformation = (props) => {
  const data = props.data;
  let Navigate = useNavigate();
  function EditRegis() {
    Navigate("/profile/editprofileuser", {
      state: {
        href: window.location.href,
      },
    });
  }
  return (
    <>
      {sessionStorage.getItem("type_user") === "corporation" ? (
        <>
          <h2 className="profile-header">รายละเอียดผู้ใช้</h2>
          <div className="account-main">
            <Accordion 
              defaultActiveKey={["0", "1", "2"]}
              alwaysOpen
              style={{ marginTop: "20px" }}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Button>
                  <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-top`}>แก้ไข</Tooltip>}
                  >
                    <i
                      className="icon-edit"
                      onClick={() => {
                        EditRegis();
                      }}
                    >
                      <TbEdit style={{ width: "30px", height: "30px" }} />
                    </i>
                  </OverlayTrigger>
                  <h4 style={{ color: "#0077B6" }}>ข้อมูลส่วนตัว</h4>
                </Accordion.Button>

                <Accordion.Body>
                  <Row
                    className="mb-3"
                    style={{
                      width: "100%",
                      fontSize: "28px",
                      margin: "auto ",
                    }}
                  >
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        เลขทะเบียนนิติบุคคล
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="input-display"
                        type="text"
                        value={data.legalentity_number}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        รหัสสาขา (ภพ. 20)
                      </Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="text"
                        //placeholder={data.f_name}
                        value={data.branch_code}
                        className="input-display"
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อีเมล</Form.Label>
                      <Form.Control
                        disabled
                        required
                        type="text"
                        //placeholder={data.l_name}
                        value={data.email}
                        className="input-display"
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Button>
                <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-top`}>แก้ไข</Tooltip>}
                  >
                    <i
                      className="icon-edit"
                      onClick={() => {
                        EditRegis();
                      }}
                    >
                      <TbEdit style={{ width: "30px", height: "30px" }} />
                    </i>
                  </OverlayTrigger>
                  <h4 style={{ color: "#0077B6" }}>ที่อยู่ปัจจุบัน</h4>
                </Accordion.Button>
                <Accordion.Body>
                  <Row
                    className="mb-3"
                    style={{
                      width: "100%",
                      fontSize: "28px",
                      margin: "auto ",
                    }}
                  >
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="input-display"
                        type="text"
                        value={data.cur_address}
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">จังหวัด</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="input-display"
                          type="text"
                          value={data.cur_province ? data.cur_province : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">ตำบล</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="input-display"
                          type="text"
                          value={data.cur_sub_dis ? data.cur_sub_dis : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อำเภอ</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="input-display"
                          type="text"
                          value={data.cur_dis ? data.cur_dis : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                      <>
                        <Form.Control
                          disabled
                          className="input-display"
                          type="text"
                          value={data.cur_poscode ? data.cur_poscode : ""}
                        />
                      </>
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        เบอร์โทรศัพท์
                      </Form.Label>
                      <Form.Control
                        disabled
                        className="input-display"
                        type="text"
                        //placeholder={data.l_name}
                        value={data.phone ? data.phone : ""}
                      />
                      <Form.Control.Feedback>!</Form.Control.Feedback>
                    </Form.Group>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </>
      ) : (
        <>
          <h2 className="profile-header">รายละเอียดผู้ใช้</h2>
          <div className="account-main">
            <Accordion
              defaultActiveKey={["0", "1", "2"]}
              alwaysOpen
              style={{ marginTop: "20px" }}
            >
              <Accordion.Item eventKey="0">
                <Accordion.Button>
                <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-top`}>แก้ไข</Tooltip>}
                  >
                    <i
                      className="icon-edit"
                      onClick={() => {
                        EditRegis();
                      }}
                    >
                      <TbEdit style={{ width: "30px", height: "30px" }} />
                    </i>
                  </OverlayTrigger>
                  <h4 style={{ color: "#0077B6" }}>ข้อมูลส่วนตัว</h4>
                </Accordion.Button>
                <Accordion.Body>
                  <Row
                    className="mb-3 "
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      margin: "auto",
                      fontSize: "28px",
                    }}
                  >
                    <Form.Group as={Col} md="2">
                      <Form.Label className="font-cen">คำนำหน้าชื่อ</Form.Label>
                      <Form.Control
                        disabled
                        placeholder={data.title}
                        className="input-display"
                      ></Form.Control>
                    </Form.Group>
                    <Form.Group as={Col} md="5">
                      <Form.Label className="font-cen">ชื่อ</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.f_name}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="5">
                      <Form.Label className="font-cen">นามสกุล</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.l_name}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        เลขบัตรประชาชน
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        //placeholder="1-2345-12345-12-3"
                        value={data.idnum}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อีเมล</Form.Label>
                      <Form.Control
                        disabled
                        type="email"
                        //placeholder="name@example.com"
                        value={data.email}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">
                        เบอร์โทรศัพท์
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        aria-label="Amount (to the nearest dollar)"
                        placeholder={data.phone}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="4">
                      <Form.Label className="font-cen">อาชีพ</Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        aria-label="Amount (to the nearest dollar)"
                        placeholder={data.occupation}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">
                        วันที่เกิด (คศ.)
                      </Form.Label>
                      <Form.Control
                        disabled
                        //type="date"
                        placeholder={data.date_of_birth}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">อายุ</Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        placeholder={data.age}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">เชื้อชาติ</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.race}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">สัญชาติ</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.nationality}
                        className="input-display"
                      />
                    </Form.Group>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1">
                <Accordion.Button>
                <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-top`}>แก้ไข</Tooltip>}
                  >
                    <i
                      className="icon-edit"
                      onClick={() => {
                        EditRegis();
                      }}
                    >
                      <TbEdit style={{ width: "30px", height: "30px" }} />
                    </i>
                  </OverlayTrigger>
                  <h4 style={{ color: "#0077B6" }}>
                    ที่อยู่ตามบัตรประชาชนหรือทะเบียนบ้าน
                  </h4>
                </Accordion.Button>
                <Accordion.Body>
                  <Row
                    className="mb-3"
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      margin: "auto",
                      fontSize: "28px",
                    }}
                  >
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                      </Form.Label>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.address}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">จังหวัด</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.province}
                        className="input-display"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">ตำบล</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.sub_dis}
                        className="input-display"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">อำเภอ</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.dis}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        placeholder={data.pos_code}
                        className="input-display"
                      />
                    </Form.Group>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2">
                <Accordion.Button>
                <OverlayTrigger
                    key={"top"}
                    placement={"top"}
                    overlay={<Tooltip id={`tooltip-top`}>แก้ไข</Tooltip>}
                  >
                    <i
                      className="icon-edit"
                      onClick={() => {
                        EditRegis();
                      }}
                    >
                      <TbEdit style={{ width: "30px", height: "30px" }} />
                    </i>
                  </OverlayTrigger>
                  <h4 style={{ color: "#0077B6" }}>ที่อยู่ปัจจุบัน</h4>
                </Accordion.Button>
                <Accordion.Body>
                  <Row
                    className="mb-3"
                    style={{
                      padding: "0px 10px",
                      width: "100%",
                      margin: "auto",
                      fontSize: "28px",
                    }}
                  >
                    <Form.Group as={Col} md="12">
                      <Form.Label className="font-cen">
                        ที่อยู่(เลขที่, หมู่ที่, อาคาร, หมู่บ้าน, ซอย, ถนน)
                      </Form.Label>
                    </Form.Group>
                    <Form.Group as={Col} md="12">
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.address}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">จังหวัด</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.province}
                        className="input-display"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">ตำบล</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.sub_dis}
                        className="input-display"
                      />
                    </Form.Group>

                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">อำเภอ</Form.Label>
                      <Form.Control
                        disabled
                        type="text"
                        placeholder={data.dis}
                        className="input-display"
                      />
                    </Form.Group>
                    <Form.Group as={Col} md="3">
                      <Form.Label className="font-cen">รหัสไปรษณีย์</Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        placeholder={data.pos_code}
                        className="input-display"
                      />
                    </Form.Group>
                  </Row>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </>
      )}
    </>
  );
};

export default UserInformation;
